module.exports = __webpack_public_path__ + "static/img/img-about-14.9e25db4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-about-14.png
// module id = Ad21
// module chunks = 0